import styles from "./Image.module.css";
import img from "../../assets/images/logo192.png";
import React, {useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faUpload} from "@fortawesome/free-solid-svg-icons";

export const ImageIllustrationUpload = ({ src, alt = null, onClick = null, baseUrl = process.env.REACT_APP_API_URL_PUBLIC }) => {
    // Vérifier si baseUrl est déjà dans src
    // Si oui, ne pas ajouter baseUrl
    // Si non, ajouter baseUrl
    if (src && src.startsWith(baseUrl)) {
        baseUrl = "";
    }
    const imageUrl = src ? `${baseUrl}${src}` : null;

    let containerClasses = imageUrl === null ? `skeleton ${styles.illustrationContainer}` : `${styles.illustrationContainer}`;

    return (
        <div className={containerClasses} onClick={onClick} title={"Cliquez pour modifier"}>
            {imageUrl ? (
                <img src={imageUrl} alt={alt} className={`${styles.illustration} ${styles.illustrationUpload}`} loading="lazy" title={"Cliquez pour modifier"}/>
            ) : (
                <p style={{ margin: "10px", textAlign: "center", fontStyle: "italic", fontWeight: "300", fontSize: "0.9rem" }} title={"Cliquez pour ajouter une image"}>
                    <FontAwesomeIcon icon={faUpload}/> Ajouter une image
                </p>
            )}
        </div>
    );
};